import { defineMessages } from "react-intl";

const baseId = "t.components.modals.OTPModal.";

export default defineMessages({
  OTPModalTitle: {
    id: baseId + "OTPModalTitle",
    defaultMessage: "Insert your OTP code",
  },
  OTPUserCodeModalTitle: {
    id: baseId + "OTPUserCodeModalTitle",
    defaultMessage: "Insert your OTP code and your User code",
  },
  OTPModalLabel: {
    id: baseId + "OTPModalLabel",
    defaultMessage: "OTP code",
  },
  OTPUserCodeModalLabel: {
    id: baseId + "OTPUserCodeModalLabel",
    defaultMessage: "User code",
  },
  OTPModalTimerMessage: {
    id: baseId + "OTPModalTimerMessage",
    defaultMessage: " Time left: ",
  },
  OTPModalTimeoutMessage: {
    id: baseId + "OTPModalTimeoutMessage",
    defaultMessage: " Timeout",
  },
  OTPModalOutOfRetrysMessage: {
    id: baseId + "OTPModalOutOfRetrysMessage",
    defaultMessage: " Out of retrys",
  },
  OTPModalClose: {
    id: baseId + "OTPModalClose",
    defaultMessage: "CLOSE",
  },
  OTPModalConfirm: {
    id: baseId + "OTPModalConfirm",
    defaultMessage: "CONFIRM",
  },
  showSecurityQuestionsModalText: {
    id: baseId + "showSecurityQuestionsModalText",
    defaultMessage: "SHOW SECURITY QUESTIONS",
  },
  showSecurityQuestionsModalLoginText: {
    id: baseId + "showSecurityQuestionsModalLoginText",
    defaultMessage: "SHOW SECURITY QUESTIONS",
  },
  errorOtp: {
    id: baseId + "errorOtp",
    defaultMessage: "ERROR",
  },
  errorOtpContent: {
    id: baseId + "errorOtpContent",
    defaultMessage: "ERROR OTP MSG",
  },
});
